import React, { useState, useEffect } from "react";
import {
  isMobile,
  isIOS,
  osVersion,
  isIOSChrome,
  isChrome,
  isAndroid,
} from "react-device-detect";
import { isMobileOrTablet } from "../components/Views/MobileClassRenderer";
import { useScrollDirection } from "react-use-scroll-direction"



const scrollDirections = {
  UP: 0,
  DOWN: 1
}

export function useDevice() {
  const [device, setDevice] = useState(null);
  const [lastScrollDirection, setLastScrollDirection] = useState(scrollDirections.UP)

  const { 
    isScrolling,
    isScrollingX,
    isScrollingY,
    isScrollingUp, 
    isScrollingDown,

  } = useScrollDirection()

  function getOSVersion() {
    return Number(osVersion.split(".")[0]);
  }

  useEffect(() => {
    if(isScrollingDown) {
      setLastScrollDirection(scrollDirections.DOWN)
    }

    if(isScrollingUp) {
      setLastScrollDirection(scrollDirections.UP)
    }
  }, [isScrollingDown, isScrollingUp])


  useEffect(() => {
    const sizes = {
      iOS15: {
        keyboard: {
          urlBarHeight: 53,
        },
      },
      iOS14: {
        keyboard: {
          urlBarHeight: 70,
        },
        urlBar: {
          height: lastScrollDirection === scrollDirections.UP ? 0 : 250
        }
      },
      isAndroid: {
        isChrome: {
          keyboard: {
            urlBarHeight: 0,
          },
          urlBar: {
            height: lastScrollDirection === scrollDirections.UP ? 55 : 0
          }
        }
      }
    };

    const newDevice = {
      isIOS15: isMobileOrTablet && isIOS && getOSVersion() == 15,
      isIOS14: isMobileOrTablet  && isIOS && getOSVersion() == 14,
      osVersion,
      isIOSChrome,
      isAndroidChrome: isMobileOrTablet() && isAndroid && isChrome,
      sizes,
    };
    // console.log(newDevice);
    setDevice(newDevice);
  }, [lastScrollDirection]);

  return device;
}
